import React, { Component } from 'react'
import {AppBar, Button, Dialog, DialogActions, DialogContent, Toolbar, Typography,} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles/index'
import { bindActionCreators } from 'redux'
import {UecareAvatar, UecareInput} from '../../../../components'
import ReduxGlobal from '../../../../store/actionreducers/globalView'
import { connect } from 'react-redux'
import { constDataDialogs } from '../../../../constants'
import UecareTextarea from "../../../../components/UecareTextarea"
import ReduxUser from "../../../../store/actionreducers/user"

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    addressButton: {
        margin: theme.spacing.unit * 1 / 2,
    },
    formControl: {
        marginBottom: 24
    },
})

const UserInfo = {
    user: {
        name:'',
        id: '',
        avatar: { url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png' },
    },
}

const customMail = {
    mailTitle: '',
    mailContext: ''
}

class FeedbackDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            user: UserInfo,
            ...customMail,
        }
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({ name: constDataDialogs.name.feedbackDialog })
    }

    _sendCustomMail = async action => {
        try {
            const {
                closeLoadingMask,
                sendCustomMail,
                openLoadingMask,
                feedback: {user: {id: userId}},
            } = this.props

            const {
                mailTitle,
                mailContext,
            } = this.state

            openLoadingMask()
            if (action === 'send') await sendCustomMail({  userId , subject: mailTitle, content: mailContext })
            closeLoadingMask()
        } catch (e) {
            console.warn('you got an error = ', e)
        }
    }

    render() {
        if (!this.props.feedbackDialog || !this.props.feedbackDialog.props.open) return <div/>

        const {
            classes,
            feedbackDialog,
            feedback: {
                user,
                title,
                content,
            },
        } = this.props

        const {
            mailTitle,
            mailContext,
        } = this.state


        return (
            <Dialog
                className={classes.root}
                {...feedbackDialog.props}
                onClose={this.closeDataDialog}
                fullWidth
                maxWidth="xs"
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">意見回饋內容</Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <UecareAvatar
                            className="w-96 h-96"
                            src={user.avatar ? user.avatar.url : 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'}
                        />
                        <Typography variant="title" color="inherit" className="pt-8">{user.name}</Typography>
                    </div>
                </AppBar>

                <DialogContent classes={{ root: 'p-24' }}>
                    <Typography style={{padding: 5}}>信箱 {user.email}</Typography>

                    <UecareTextarea
                        label="主旨"
                        icon="note"
                        name="title"
                        id="title"
                        className={classes.formControl}
                        value={title || ''}
                    />
                    <UecareTextarea
                        label="內容"
                        name="content"
                        id="content"
                        className={classes.formControl}
                        value={content || ''}
                    />
                    {/* 回覆信件的輸入元件 */}
                    <UecareInput
                        label="回信主旨"
                        icon="date_range"
                        name="updated_at"
                        id="updated_at"
                        className={classes.formControl}
                        value={mailTitle}
                        onChange={(event) => this.setState({ mailTitle: event.target.value })}
                    />

                    <UecareTextarea
                        label="回信內文"
                        icon="note"
                        name="note"
                        id="note"
                        className={classes.formControl}
                        value={mailContext}
                        onChange={(event) => this.setState({ mailContext: event.target.value })}
                    />

                </DialogContent>

                <DialogActions>
                    <Button variant="raised" color="secondary" onClick={() => this._sendCustomMail('send')}>發送信件</Button>
                </DialogActions>

            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        sendCustomMail: ReduxUser.ActionCreator.sendCustomMail,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch)
}

function mapStateToProps({ global: { dataDialogs } }) {
    return {
        feedbackDialog: dataDialogs[constDataDialogs.name.feedbackDialog],
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(FeedbackDialog))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/feedback/FeedbackDialog.js